import React, { useState, useEffect } from 'react'
import useSWR from 'swr'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { useDex } from '../../hooks/useDex'
import { useConnectWallet } from '../../hooks/useConnectWallet'
import {
  displayCurrency,
  escapeRegExp,
  displayCurrencyForInput,
} from '../../utils/helpers'
import { isCorrectNetwork } from '../../utils'
import { getWithExpiry } from '../../utils/localstoageHelper'
import ModalStatus from '../../components/ModalStatus'
import ILogo from '../../images/logo.png'
import IToken from '../../images/token.png'
import ICoin from '../../images/coin.png'
import './style.scss'
import { NAME_TOKEN, MIN_SWAP } from '../../constants'
import { useSelector, useDispatch } from 'react-redux'
import { fetchAffiliateAddress } from '../../redux/slices/affiliateSlice'
// import { useQuery } from '../../hooks/useQuery'
import { useParams } from 'react-router-dom'
import { useModalStatus } from '../../hooks/useModalStatus'

const Swap = () => {
  const { account, library, chainId, connectWallet } = useConnectWallet()

  // const query = useQuery().get('ref')

  const dispatch = useDispatch()
  const affiliate = useSelector((state) => state.affiliate)

  let { ref } = useParams<any>()

  const {
    setShowModal,
    // modalStatusState,
    setCloseModalStatus,
  } = useModalStatus()
  // const { isShowModalStatus } = modalStatusState

  useEffect(() => {
    const refLocalstoage: string = getWithExpiry('refCode')
    if (ref || refLocalstoage) getAffiliateAddress(ref || refLocalstoage)
  }, [])

  const getAffiliateAddress = (refCode: string) => {
    const data = {
      ref: refCode,
      buyerAddress: account,
    }
    dispatch(fetchAffiliateAddress(data))
  }

  const {
    buyToken,
    buyTokenWithRefAffiliate,
    getRatioValue,
    modalStatus,
    // setModalStatus,
  } = useDex()

  const [amountCoin, setAmountCoin] = useState<string>('')
  const [amountToken, setAmountToken] = useState<string>('')
  const [maxBalance, setMaxBalance] = useState<string>('')
  const [focusIndex, setFocus] = useState<string>('-1')

  const handleBuyToken = () => {
    if (ref || affiliate.address) {
      buyTokenWithRefAffiliate(amountCoin, affiliate.address, ref)
    } else {
      buyToken(amountCoin) // without affiliate
    }
  }

  const fetcher = (library: any) => (...args: any) => {
    const [method, ...params] = args
    return library[method](...params)
  }

  const Balance = () => {
    const { data: balance } = useSWR(['getBalance', account, 'latest'], {
      fetcher: fetcher(library),
    })

    if (!balance) {
      return null
    }
    setMaxBalance(displayCurrency(balance, 6))

    return (
      <div className='text-input'>
        Balance: {displayCurrency(balance, 6).toString()}
      </div>
    )
  }

  const onClickMaxAmount = () => {
    onChangeAmountCoin(maxBalance)
  }

  //const  isCorrectNetwork  = isCorrectNetwork(chainId)

  const handleConfirmBuy = () => {
    // setModalStatus(true, 'Confirm Swap', 'content')
    setShowModal({
      isShowModalStatus: true,
      title: 'Confirm Swap',
      contentType: 'content',
    })
  }

  const buttonBuy = () => {
    if (account && library) {
      const isValid = !!(Number(amountCoin) && Number(amountToken))
      const isInsufficient = Number(amountCoin) > Number(maxBalance)
      const isValidMin =
        Number(amountToken) >= 0 && Number(amountToken) < MIN_SWAP

      if (!isCorrectNetwork(chainId)) return null

      if (!isValid)
        return (
          <button
            className={`btn footer--button active disable`}
            onClick={handleConfirmBuy}
            disabled
          >
            Enter an Amount
          </button>
        )

      if (isValidMin) {
        return (
          <button
            className={`btn footer--button active disable`}
            onClick={handleConfirmBuy}
            disabled
          >
            {`Minimum swap is ${MIN_SWAP} OneP`}
          </button>
        )
      }

      if (isValid && !isInsufficient)
        return (
          <button
            className={`btn footer--button active`}
            onClick={handleConfirmBuy}
          >
            Buy
          </button>
        )

      if (isValid && isInsufficient) {
        return (
          <button
            className={`btn footer--button active disable`}
            onClick={handleConfirmBuy}
            disabled
          >
            Insufficient BNB balance
          </button>
        )
      }
    } else {
      return (
        <button onClick={connectWallet} className='btn footer--button active'>
          Unlock Wallet
        </button>
      )
    }
  }

  const onChangeAmountCoin = async (data: string) => {
    if (data) {
      setAmountCoin(data)
      const tmpToken = await getRatioValue(data, true)
      if (tmpToken) setAmountToken(displayCurrencyForInput(tmpToken))
    } else {
      setAmountCoin('')
      setAmountToken('')
    }
  }

  const onChangeAmountToken = async (data: string) => {
    if (data) {
      setAmountToken(data)
      const tmpCoin = await getRatioValue(data, false)
      if (tmpCoin) setAmountCoin(displayCurrencyForInput(tmpCoin))
    } else {
      setAmountCoin('')
      setAmountToken('')
    }
  }

  const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`)

  const CardInput = React.memo(function InnerInput({
    label,
    value,
    onChange,
    placeholder,
    id,
    key,
    focusIndex,
    onFocus,
    onBlur,
  }: {
    label: string
    value: string | number
    onChange: (input: string) => void
    id: string
    key: string
    focusIndex: string
    onFocus: (input: string) => void
    onBlur: (input: string) => void
  } & Omit<React.HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'as'>) {
    const isFrom = label === 'From'

    const enforcer = (nextUserInput: string) => {
      if (
        nextUserInput === '' ||
        inputRegex.test(escapeRegExp(nextUserInput))
      ) {
        onChange(nextUserInput)
      }
    }

    return (
      <div className='card-input'>
        <div className='card-input--container'>
          <div className='label-input'>
            <div className='text-input'>{label}</div>
            {isFrom && <Balance />}
          </div>
          <div className='container-input'>
            <input
              id={id}
              key={key}
              className='input-swap'
              value={value}
              onChange={(event) => {
                enforcer(event.target.value.replace(/,/g, '.'))
              }}
              onFocus={onFocus}
              inputMode='decimal'
              title='Token Amount'
              autoComplete='off'
              autoCorrect='off'
              autoFocus={focusIndex == id}
              type='text'
              pattern='^[0-9]*[.,]?[0-9]*$'
              placeholder={placeholder || '0.0'}
              minLength={1}
              maxLength={79}
              spellCheck='false'
              onBlur={onBlur}
            />
            {isFrom && (
              <button className='btn btn-max-amount' onClick={onClickMaxAmount}>
                MAX
              </button>
            )}
            {isFrom ? (
              <div className='icon-token-container'>
                <span>
                  <img alt='' src={ICoin} />
                  <div className='text-icon'>BNB</div>
                </span>
              </div>
            ) : (
              <div className='icon-token-container'>
                <span>
                  <img alt='' src={IToken} />
                  <div className='text-icon'>{NAME_TOKEN}</div>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  })

  return (
    <div className='main-swap'>
      <div className='container'>
        <div className='wrap-logo'>
          <img alt='' src={ILogo} />
        </div>
        <div className='card-swap'>
          <div className='card-swap--header'>
            <h3 color='text' className='text'>
              Swap
            </h3>
          </div>
          <div className='card-swap--content'>
            <div className='content'>
              <CardInput
                id='1'
                key={'from'}
                label='From'
                value={amountCoin}
                onChange={onChangeAmountCoin}
                focusIndex={focusIndex}
                onFocus={() => setFocus('1')}
                onBlur={() => setFocus('-1')}
              />
              <div className='d-flex justify-content-center m-2'>
                <FontAwesomeIcon
                  icon={faArrowDown}
                  className='icon-arrow-down'
                />
              </div>
              <CardInput
                label='To'
                id='2'
                key={'to'}
                value={amountToken}
                onChange={onChangeAmountToken}
                focusIndex={focusIndex}
                onFocus={() => setFocus('2')}
                onBlur={() => setFocus('-1')}
              />
            </div>
            <div className='footer'>{buttonBuy()}</div>
            <div className='footer-note'>
              <label>{`The minimum swap is ${MIN_SWAP} OneP `}</label>
            </div>
          </div>
        </div>
      </div>

      <ModalStatus
        modalStatus={modalStatus}
        onCloseModal={setCloseModalStatus}
        onConfirm={handleBuyToken}
        compContent={
          <div className='summary-content'>
            <div className='wrap-content'>
              <label className='txt-sum'>{amountCoin}</label>
              <span>
                <img alt='' src={ICoin} />
                <div className='text-icon'>BNB</div>
              </span>
            </div>
            <div className='d-flex justify-content-center m-3'>
              <FontAwesomeIcon icon={faArrowDown} className='icon-arrow-down' />
            </div>
            <div className='wrap-content'>
              <label className='txt-sum'>{amountToken}</label>
              <span>
                <img alt='' src={IToken} />
                <div className='text-icon'>{NAME_TOKEN}</div>
              </span>
            </div>
          </div>
        }
      />
    </div>
  )
}

export default Swap
